import React from "react";

const Select = ({ name, label, options, error, ...rest }) => {
  return (
    <React.Fragment>
      <select name={name} id={name} {...rest} className="form-control">
        <option value="" />
        {options.map((option, idx) => (
          <option key={idx} value={option}>
            {option}
          </option>
        ))}
      </select>
      {error && <div className="alert alert-danger">{error}</div>}
    </React.Fragment>
  );
};

export default Select;
